import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
  text: {
    marginBottom: theme.spacing(1),
    width: 300,
    textAlign: 'center',
  },
  wrap: {
    '& h4': {
      marginBottom: 40,
    },
  },
}));

function TestABC (props) {
  const classes = useStyles();
  const { q, a, setAnswer } = props;

  return (
    <div className={classes.wrap}>
      <div className={classes.test}>
        <h4>{q.sentence}</h4>
        <TextField
          variant="outlined"
          value={a ? a : ''}
          onChange={ev => setAnswer(ev.target.value)}
          className={classes.text}
        />
      </div>
    </div>
  );
}

export default TestABC;
